import { IPouchState, } from './types';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PouchLoadStatus } from 'app/actions/pouch.actions';

const NS = 'pouchSlice';

const initialState: IPouchState = {
  pouchLoadedStatus: PouchLoadStatus.idle,
};

const pouchSlice = createSlice({
  name: 'pouch', // used in action types
  initialState,
  reducers: {
    setPouchLoadStatus: (state: IPouchState, action: PayloadAction<PouchLoadStatus>) => {
      state.pouchLoadedStatus = action.payload;
    },
    reset: () => {
      return initialState;
    },
  },
});

// Extract the action creators object and the reducer
const { actions, reducer } = pouchSlice;
// Extract and export each action creator by name
export { actions as pouchActions };
// Export the reducer, either as a default or named export
export default reducer;
